import React, { useState, useEffect } from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { Paper, Chip } from "@mui/material";

const chipSx = {
  "& .MuiInputLabel-root": {
    fontSize: ["1rem", "1rem", "1rem", "1rem", "1rem", "1rem"],
  },
  "& .MuiFilledInput-root": {
    pt: ["1rem", "1rem", ".75rem", ".75rem", "1.25rem", "1.25rem"],
  },
  "& .MuiFilledInput-input": {
    m: ["0rem", "0rem", "0rem", "0rem", ".1rem", ".1rem"],
  },
  "& .MuiAutocomplete-input": {
    padding: "3 !important",
    height: ["1rem", "1rem", "1rem", "1rem", "1.5rem", "1.5rem"],
  },
  "& .MuiTextField-root": {
    marginTop: [".5rem", ".5rem", ".75rem", ".75rem", "1rem", "1rem"],
  },
  "& .MuiChip-root": {
    height: ["1.5rem", "1.5rem", "1.25rem", "1.25rem", "1.85rem", "1.85rem"],
    m: ["0rem", "0rem", ".15rem", ".25rem", ".25rem", ".25rem"],
  },
  "& .MuiChip-label": {
    fontSize: [".5rem", ".5rem", ".75rem", ".75rem", "1.05rem", "1.05rem"],
    px: [".5rem", ".5rem", ".5rem", ".5rem", ".60rem", ".60rem"],
  },
  "& .MuiChip-deleteIcon": {
    fontSize: [
      "1.5rem",
      "1.5rem",
      "1rem !important",
      "1rem !important",
      "1.5rem !important",
      "1.5rem !important",
    ],
  }
};

export const RenderAutocompleteMultiple = (inputProps) => {
  const {
    input,
    // eslint-disable-next-line no-unused-vars
    value: givenValue,
    // eslint-disable-next-line no-unused-vars
    fieldValue,
    label,
    meta,
    disabled,
    hideFormErrors,
    inputProps: extraProps,
    options,
    helperText,
    multilineFlag = false,
    chipColor = null,
    outlined = true,
    inputSX = null,
    ...autocompleteprops
  } = inputProps;
  let error =
    meta?.error?.[0] && !hideFormErrors && (meta.touched || meta.submitFailed)
      ? meta.error[0]
      : undefined;

  let errorIndex = meta?.error?.errorIndex;
  if (errorIndex) {
    error = meta?.error?.message;
  }
  const { onChange, name: inputName, ...rest } = input;
  const [inputValue, setInputValue] = useState('')

  useEffect(() => {
    setInputValue('')
  }, [inputName])

  return (
    <Autocomplete
      freeSolo
      fullWidth={true}
      selectOnFocus
      multiple
      inputValue={inputValue}
      onChange={(e, newValue) => {
        console.log('why', newValue)
        onChange([...newValue]);
        if (e?.key === 'Enter') {
          if (inputValue.length > 0
            && !inputProps?.value?.includes(inputValue)) {
            setInputValue('')
          }
        }
        if (newValue.length > 0) {
          setInputValue('')
        }
      }}
      value={fieldValue || []}
      disabled={disabled}
      options={options ? options : []}
      {...autocompleteprops}
      sx={{
        ...chipSx,
        ...(inputSX !== null ? {
          "& .MuiTextField-root": {
            marginTop: 0,
            marginLeft: "-.5rem"
          },
        } : {}),
        width: "100%",
        '& .MuiTextField-root': {
          backgroundColor: "rgba(0, 0, 0, 0.06)",
        },
        "& .MuiInput-root": {
          mt: ["0.5rem", ".5rem", ".5rem", ".5rem", "1rem", "1rem"],

        },
        "& .MuiInputBase-root": {
          fontSize: [".5rem", ".5rem", ".75rem", ".75rem", "1rem", "1rem"],
        },
        "& .MuiOutlinedInput-notchedOutline >legend": {
          fontSize: [".75rem", ".75rem", ".75rem", ".75rem", ".75rem", ".75rem"],
        },
        "& .MuiSvgIcon-root": {
          fontSize: ["1rem", "1rem", "1rem", "1rem", "1.5rem", "1.5rem"],
        },
        '& .MuiOutlinedInput-root': {
          py: ['3.5px', '3.5px', '3.5px', '3.5px', '9px', '9px']
        }
      }}
      PaperComponent={({ children }) => (
        <Paper
          sx={{
            fontSize: [
              ".5rem",
              ".5rem",
              ".8rem",
              ".8rem",
              "1.15rem",
              "1.15rem",
            ],
          }}
        >
          {children}
        </Paper>
      )}
      renderTags={(value, getTagProps) =>
        value.map((option, index) => {
          let errorColor = false;
          if (errorIndex?.length > 0) {
            if (errorIndex.includes(index)) {
              errorColor = true;
            }
          }

          let curChipColor = errorColor ? "#d32f2f" : chipColor;
          const { key, ...tagProps } = getTagProps({ index })

          return (
            <Chip
              sx={{
                ...chipSx,
                ...(curChipColor
                  ? {
                    color: curChipColor,
                    borderColor: curChipColor,
                    "& .MuiChip-deleteIcon": { color: curChipColor },
                  }
                  : {}),
              }}
              variant="outlined"
              label={option}
              key={key}
              {...tagProps}
            />
          );
        })
      }
      renderInput={(params) => (
        <TextField
          {...params}
          {...rest}
          name={inputName}
          label={label}
          variant={outlined ? "outlined" : "standard"}
          error={error ? true : false}
          helperText={error ? error : helperText}
          multiline={multilineFlag}
          InputProps={{
            ...(params?.InputProps || {}),
            ...(rest?.InputProps || {}),
            // disableUnderline: true,
          }}
          onChange={(e) => {
            setInputValue(e.target.value)
          }}
          onKeyUp={(e) => {
            if (e.key === 'Enter') {
              setInputValue('')
            }
          }}
          onBlur={(e) => {
            if (e.target.value.length > 0) {
              if (!fieldValue.includes(e.target.value)) {
                onChange([...fieldValue, e.target.value]);
                setInputValue('')
              }
            }
          }}
        />
      )}
      {...extraProps}
    />
  );
};
